import React from "react"
import { graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import { PrismicRichText } from "@prismicio/react"

export const ArticleWithImage = ({ slice }) => {
  // console.log("ArticleWithImage Slice: ", slice)

  return (
    <div className={`article_with_image`}>
      <section className="bg-c-7 py-st-2">
        <Container className="">
          <Row className="justify-content-center">
            <Col className="col-lg-8 bg-white rounded-3 p-st-3">
              <PrismicRichText
                field={slice.primary.description.richText}
                components={{
                  paragraph: ({ children, key }) => (
                    <p className="paragraph-st fs-st-11 py-2 lh-md" key={key}>
                      {children}
                    </p>
                  ),
                  heading3: ({ children, key }) => (
                    <h3 className="heading-st fs-st-8 py-3" key={key}>
                      {children}
                    </h3>
                  ),
                  image: ({ node, key }) => {
                    return (
                      <div
                        key={key}
                        className="block-img d-flex align-items-start justify-content-center p-lg-4 my-3 filter-st-1"
                      >
                        <img
                          className="img-fluid"
                          src={node.url}
                          alt={node.alt ?? undefined}
                          data-copyright={
                            node.copyright ? node.copyright : undefined
                          }
                          loading="lazy"
                        />
                      </div>
                    )
                  },
                  oList: ({ children }) => (
                    <ol className="ol-st-2">{children}</ol>
                  ),
                  oListItem: ({ children, key }) => (
                    <li className="li-st-2 paragraph-st fs-st-11" key={key}>
                      {children}
                    </li>
                  ),
                  list: ({ children }) => (
                    <ul className="ul-st-1">{children}</ul>
                  ),
                  listItem: ({ children, key }) => (
                    <li className="li-st-1 paragraph-st fs-st-11" key={key}>
                      {children}
                    </li>
                  ),
                }}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export const query = graphql`
  fragment PageDataBodyArticleWithImage on PrismicPageDataBodyArticleWithImage {
    id
    slice_type
    primary {
      description {
        text
        richText
      }
    }
  }
`
